module.exports = __webpack_public_path__ + "static/img/12.7918de2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/2/1/sp/12.png
// module id = 7LGx
// module chunks = 0